import RangePicker from '~/js/components/vendor/react-dates/RangePicker';
import { ANCHOR_LEFT, ANCHOR_RIGHT } from 'react-dates/lib/constants';
import moment from 'moment';

/* eslint-disable */

const { Component } = React;

class DatesSelector extends Component {
    static defaultProps = {
        anchorDirection: window.innerWidth < 768 ? ANCHOR_LEFT : ANCHOR_RIGHT,
        numberOfMonths: window.innerHeight > 991 ? 2 : 1,
        noLabels: false
    };

    constructor(props) {
        super(props);

        this.state = {
            startDate: null,
            endDate: null,
            focusedInput: null,
            fields: {
                arrival: '',
                departure: ''
            }
        };
    }

    componentDidMount() {
        $('#arrival').attr('required', true);
        $('#departure').attr('required', true);
    }

    _onFocusChange = focusedInput => this.setState({ focusedInput });

    _onDatesChange = ({ startDate, endDate }) => {
        const { ...fields } = this.state.fields;

        fields.startDate =
            startDate && startDate.clone().format(this.DATE_FORMAT);
        fields.endDate = endDate && endDate.clone().format(this.DATE_FORMAT);

        this.setState({ startDate, endDate, fields });

        const startPickerDate = moment(startDate, 'DD/MM/YYYY');
        const endPickerDate = moment(endDate, 'DD/MM/YYYY');

        const result = endPickerDate.diff(startPickerDate, 'days');

        $('#numNights').val(result);
    };

    render() {
        return (
            <RangePicker
                startDateId={this.props.fromName}
                endDateId={this.props.toName}
                focusedInput={this.state.focusedInput}
                onFocusChange={this._onFocusChange}
                onDatesChange={this._onDatesChange}
                startDateLabelText="Arrival"
                endDateLabelText="Departure"
                displayFormat="DD/MM/YYYY"
                startDateLabelText="Arrival"
                endDateLabelText="Departure"
                startDatePlaceholderText="dd/mm/yyyy"
                endDatePlaceholderText="dd/mm/yyyy"
                anchorDirection={this.props.anchorDirection}
                noLabels={this.props.noLabels}
                numberOfMonths={
                    window.innerWidth > 991 ? this.props.numberOfMonths : 1
                }
                minimumNights={1}
            />
        );
    }
}

export default DatesSelector;
